import { h, render } from 'preact'
import TableOfContentsEnhancedApp from './containers/App/index'

const TableOfContentsEnhanced = () => {
  let $component
  let props = {}

  const self = {
    init () {
      $component = document.querySelector('.TableOfContentsEnhanced')
      if (!$component) return

      props = {
        targetSelector: $component.getAttribute('data-target-selector')
      }

      render(<TableOfContentsEnhancedApp {...props} />, $component)
    }
  }

  return self
}

export default TableOfContentsEnhanced
